import { FirebaseApp, initializeApp } from 'firebase/app'
import { getStorage } from 'firebase/storage'
import { getAnalytics } from 'firebase/analytics'
import {
  connectFunctionsEmulator,
  getFunctions,
  httpsCallable,
} from 'firebase/functions'
import { getMessaging } from 'firebase/messaging'
import {
  indexedDBLocalPersistence,
  initializeAuth,
  signInAnonymously,
} from 'firebase/auth'

const signIn = async (fbApp: FirebaseApp) => {
  const fbAuth = initializeAuth(fbApp, {
    persistence: indexedDBLocalPersistence,
  })
  if (fbAuth.currentUser) return

  try {
    const signInResponse = await signInAnonymously(fbAuth)
  } catch (e) {
    console.error('Firebase login error:', e)
  }
}

type FbSendResponse = {
  isSuccess: boolean
  message: string
  status: string
}

export const fbSetup = async () => {
  const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
    measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
  }
  const fbApp = initializeApp(firebaseConfig)

  await signIn(fbApp)
  const fbStorage = getStorage(fbApp)
  const fbFunctions = getFunctions(fbApp)
  const inServiceWorker = typeof ServiceWorkerGlobalScope !== 'undefined'
  const fbAnalytics = inServiceWorker ? undefined : getAnalytics(fbApp)

  /* EMULATOR if needed * /
  console.log(
    'fbSetup: emulating firebase functions for region:',
    fbFunctions.region
  )
  connectFunctionsEmulator(fbFunctions, '127.0.0.1', 5001)
  /**/

  // Callable functions
  const storePushSubscription = httpsCallable(
    fbFunctions,
    'storePushSubscription'
  )
  const removePushSubscription = httpsCallable(
    fbFunctions,
    'removePushSubscription'
  )
  const sendPushNotication = httpsCallable<unknown, FbSendResponse>(
    fbFunctions,
    'sendPushNotification'
  )

  return {
    fbStorage,
    fbAnalytics,
    fbFunctions,
    fbStorePushSubscription: storePushSubscription,
    fbRemovePushSubscription: removePushSubscription,
    fbSendPushNotification: sendPushNotication,
  }
}
